module.exports = __webpack_public_path__ + "sr.svg?f67016269c4ca77249ae6142f99cc626";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sr.svg
// module id = 1382
// module chunks = 27